import { get } from '@/services/http';
import List from './list';
import AbstractModel from '../models//abstract_model';

export default class Collection<Type> extends List<Type> {
  public async load(model: any): Promise<Type[]> {
    if (this.items.length > 0) {
      return this.items;
    }
    const data: [] = await model.getResource().load();
    if ( data != null && data.length > 0 ) {
      for ( const item of data) {
        this.add(model.create(item));
      }
    }
    return [];
  }
}
